import { useClaimStore, useNotificationStore } from "@/store";

export default function openTribunalDigitalForCurrentClaim() {
  const procedure = useClaimStore().claim?.procedure;
  if (!procedure) {
    useNotificationStore().emitNotification({
      type: "error",
      title: "Aucun numéro RG rattaché au dossier"
    });
  } else {
    const juridictionCode = procedure.juridiction.code;
    const numeroRG = procedure.identifier;
    const urlAffaire = `https://www.tribunaldigital.fr/front-td/app/procedure/detail?juridiction=${juridictionCode}&numeroRG=${numeroRG}&isAffaireAdded=false`;
    console.log("Url Affaire:", urlAffaire);
    window.open(urlAffaire, "_blank", "noopener,noreferrer")?.focus();
  }
}